import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const QuestionnaireLoadingIndicator = () => (
  <div className="z-1 pointer-events-auto absolute inset-0 flex items-center justify-center bg-white opacity-80">
    <FontAwesomeIcon icon={faCircleNotch} spin size="6x" aria-label="loading" />
  </div>
);
